import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { TeamMemberSummariesActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createTeamMemberSummary = (data): any => action(types.CREATE_TEAM_MEMBER_SUMMARY_REQUESTED, data);

export const updateTeamMemberSummary = (data): any => action(types.UPDATE_TEAM_MEMBER_SUMMARY_REQUESTED, data);

export const deleteTeamMemberSummary = (teamMemberSummaryId): any => action(types.DELETE_TEAM_MEMBER_SUMMARY_REQUESTED, teamMemberSummaryId);

export const getTeamMemberSummary = (teamMemberSummaryId): any => action(types.GET_TEAM_MEMBER_SUMMARY_REQUESTED, teamMemberSummaryId);

export const getAllTeamMemberSummaries = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_TEAM_MEMBER_SUMMARY_SUMMARIES_REQUESTED, { pagination, compile });

export const getAllTeamMemberSummariesTeamMemberSummaryView = (
  pagination: IPagination = undefined,
  compile = true,
  teamCode = undefined,
  teamMemberSummaryCode = undefined,
): any => action(types.GET_ALL_TEAM_MEMBER_SUMMARY_SUMMARIES_REQUESTED, {
  pagination,
  compile,
  teamMemberSummaryView: true,
  teamCode,
  teamMemberSummaryCode,
});

export const selectTeamMemberSummary = (teamMemberSummaryId): any => action(types.SELECT_TEAM_MEMBER_SUMMARY_REQUESTED, {
  currentTeamMemberSummaryId: teamMemberSummaryId,
});
export const clearTeamMemberSummaries = (): any => action(types.CLEAR_TEAM_MEMBER_SUMMARY_SUMMARIES);

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createTeamMemberSummaryPending: (payload): any => action(types.CREATE_TEAM_MEMBER_SUMMARY_PENDING, payload),
  createTeamMemberSummariesSuccess: (response): any => action(types.CREATE_TEAM_MEMBER_SUMMARY_SUCCESS, {
    teamMemberSummariesById: response.entities.teamMemberSummaries,
    currentTeamMemberSummaryId: response.result,
  }),
  updateTeamMemberSummaryPending: (payload): any => action(types.UPDATE_TEAM_MEMBER_SUMMARY_PENDING, payload),
  updateTeamMemberSummariesSuccess: (response): any => action(types.UPDATE_TEAM_MEMBER_SUMMARY_SUCCESS, {
    teamMemberSummariesById: response.entities.teamMemberSummaries,
    currentTeamMemberSummaryId: response.result,
  }),
  updateTeamMemberSummaryFailed: (error): any => action(types.UPDATE_TEAM_MEMBER_SUMMARY_FAIL, { backendErrors: error }),
  deleteTeamMemberSummaryPending: (response): any => action(types.DELETE_TEAM_MEMBER_SUMMARY_PENDING, response),
  deleteTeamMemberSummariesSuccess: (response): any => action(types.DELETE_TEAM_MEMBER_SUMMARY_SUCCESS, {
    currentTeamMemberSummaryId: response,
  }),
  getTeamMemberSummaryPending: (): any => action(types.GET_TEAM_MEMBER_SUMMARY_PENDING, {}),
  getTeamMemberSummariesSuccess: (response): any => action(types.GET_TEAM_MEMBER_SUMMARY_SUCCESS, {
    teamMemberSummariesById: response.entities.teamMemberSummaries,
    currentTeamMemberSummaryId: response.result,
  }),
  getTeamMemberSummaryFailed: (error): any => action(types.GET_TEAM_MEMBER_SUMMARY_FAIL, { backendErrors: error }),
  deleteTeamMemberSummaryFailed: (error): any => action(types.DELETE_TEAM_MEMBER_SUMMARY_FAIL, { backendErrors: error }),
  getAllTeamMemberSummariesPending: (pagination): any => action(types.GET_ALL_TEAM_MEMBER_SUMMARY_SUMMARIES_PENDING, { pagination }),
  getAllTeamMemberSummariesSuccess: (response, meta): any => action(types.GET_ALL_TEAM_MEMBER_SUMMARY_SUMMARIES_SUCCESS, {
    teamMemberSummariesById: response.entities.teamMemberSummaries,
    teamMemberSummaryIds: response.result,
    meta,
  }),
  getAllTeamMemberSummariesFailed: (error): any => action(types.GET_ALL_TEAM_MEMBER_SUMMARY_SUMMARIES_FAIL, { backendErrors: error }),
  createTeamMemberSummaryFailed: (error): any => action(types.CREATE_TEAM_MEMBER_SUMMARY_FAIL, { backendErrors: error }),
};

export default null;
